import { render } from "./designDescriptionPrint.vue?vue&type=template&id=f277d348"
import script from "./designDescriptionPrint.vue?vue&type=script&lang=js"
export * from "./designDescriptionPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__